import circleSolid from '../media/chart/CircleSolid.svg';
import circleDotted from '../media/chart/CircleDotted.svg';
import diamondSolid from '../media/chart/DiamondSolid.svg';
import diamondDotted from '../media/chart/DiamondDotted.svg';
import triangleDownSolid from '../media/chart/TriangleDownSolid.svg';
import triangleDownDotted from '../media/chart/TriangleDownDotted.svg';
import triangleUpSolid from '../media/chart/TriangleUpSolid.svg';
import triangleUpDotted from '../media/chart/TriangleUpDotted.svg';

const metricPickerBorderColor = [
  '#2e76bc',
  '#022F22',
  '#e2068c',
  '#4a0b3f',
];

const getMetricPickerBorderStyle = column => ({
  border: `1px solid ${metricPickerBorderColor[column]}`,
  borderRadius: '4px',
});

export const getPerformanceCardFluentV2Style = palette => ({
  '.overview-card-container.CardType-Performance': {
    height: '430px',
    '& .overview-card': {
      height: '410px',
    },
  },
  '.overview-card .performance-graph': {
    flexBasis: 'auto',
  },
  '.performance-card': {
    display: 'flex',
    flexDirection: 'column',
    '& .performance-card-metrics-picker': {
      display: 'flex',
      marginBottom: '20px',
      gap: '12px',

      '& .metric-picker__text': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        maxWidth: '86px',

        '&:hover': {
          background: palette.neutralLighter,
        },
      },
      '& .performance-card-metrics-picker__metric': {
        display: 'flex',
        flex: '0 1 auto',
        padding: '14px 4px',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '6px',

        border: '1px solid #d1d1d1',
        borderRadius: '4px',
        width: '160px',
        height: '80px',

        '& .marker-container': {
          display: 'flex',
          minWidth: '14px',
        },

        '& .metric-picker': {
          borderStyle: 'solid',
          borderColor: 'transparent',
          justifyContent: 'center',
          padding: '0px',
          height: '55px',
          minWidth: '60px',
          alignItems: 'flex-start',

          '&:hover': {
            background: 'transparent',
          },
        },

        '& .marker': {
          backgroundRepeat: 'no-repeat',
          width: 14,
          height: 48,
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          flex: 'none',
        },

        '& .open>.dropdown-menu': {
          zIndex: 6,
          top: '20px',
        },
      },

      '& .performance-card-metrics-picker__metric--column0': {
        '& .original-marker': {
          backgroundImage: `url("${circleSolid}")`,
        },
        '& .comparison-marker': {
          backgroundImage: `url("${circleDotted}")`,
        },
        ...getMetricPickerBorderStyle(0),
      },
      '& .performance-card-metrics-picker__metric--column1': {
        '& .original-marker': {
          backgroundImage: `url("${diamondSolid}")`,
        },
        '& .comparison-marker': {
          backgroundImage: `url("${diamondDotted}")`,
        },
        ...getMetricPickerBorderStyle(1),
      },
      '& .performance-card-metrics-picker__metric--column2': {
        '& .original-marker': {
          backgroundImage: `url("${triangleDownSolid}")`,
        },
        '& .comparison-marker': {
          backgroundImage: `url("${triangleDownDotted}")`,
        },
        ...getMetricPickerBorderStyle(2),
      },
      '& .performance-card-metrics-picker__metric--column3': {
        '& .original-marker': {
          backgroundImage: `url("${triangleUpSolid}")`,
        },
        '& .comparison-marker': {
          backgroundImage: `url("${triangleUpDotted}")`,
        },
        ...getMetricPickerBorderStyle(3),
      },
      '& .metric-picker .metric-picker__button.metric-picker__button--caret.dropdown-toggle.btn.btn-default': {
        height: 'auto',
      },
    },
  },
});
